import type { SelectOption } from "@clintonelec/react-storybook";
import { SnmpAuthenticationProtocol, SnmpPrivacyProtocol, SnmpType } from "Interfaces";

export const ipNetworkSettingsWarningMessage = "If for some reason the IP camera fails to acquire an IP address," +
	" you will need to use the admin tool to find this unit.";

export const invalidIpValidityMessage = "Invalid IP Address";

export const invalidHttpPortValueMessage = "Port number must be 80 or between 1024 ~ 65535";
export const invalidRtspPortValueMessage = "Port number must be 554 or between 1024 ~ 65535";
export const invalidHttpsPortValueMessage = "Port number must be 443 or between 1024 ~ 65535";

export const cidrRegex = "^(12[0-8]|1[01][0-9]|[1-9]?[0-9])$";

export enum NetworkType {
	OFF = "Off",
	DHCP_AUTOMATIC_DNS = "DHCP and Automatic DNS",
	DHCP_MANUAL_DNS = "DHCP and Manual DNS",
	MANUAL = "Manual"
}

export const networkTypeSelectOptions: SelectOption[] = Object.values(NetworkType).map(option => ({
	label: option,
	value: option
}));

export const snmpTypeOptions: SelectOption[] = [
	{
		label: "None",
		value: SnmpType.NONE
	},
	{
		label: "SNMP v2",
		value: SnmpType.V2
	},
	{
		label: "SNMP v3",
		value: SnmpType.V3
	}
];

export const snmpAuthProtocolOptions: SelectOption[] = [
	{
		label: "None",
		value: SnmpAuthenticationProtocol.NONE
	},
	{
		label: "MD5",
		value: SnmpAuthenticationProtocol.MD5
	},
	{
		label: "SHA",
		value: SnmpAuthenticationProtocol.SHA
	}
];

export const snmpPrivacyProtocolOptions: SelectOption[] = [
	{
		label: "None",
		value: SnmpPrivacyProtocol.NONE
	},
	{
		label: "DES",
		value: SnmpPrivacyProtocol.DES
	},
	{
		label: "AES",
		value: SnmpPrivacyProtocol.AES
	}
];
